import MainWrapper from "@/components/base/MainWrapper";
import RegionPage from "@/components/region/RegionPage";
import CountryPage from "@/components/country/CountryPage";
import CityPage from "@/components/city/CityPage";
import TourPage from "@/components/tour/TourPage";
import {fetchStaticPaths, fetchStaticProps} from "@/services/dataFetcher";

export const renderPage = (type, data) => {
    switch (type) {
        case 'region':
            return <RegionPage data={data} />;
        case 'country':
            return <CountryPage data={data} />;
        case 'city':
            return <CityPage data={data} />;
        case 'tour':
            return <TourPage data={data} />;
        case 'world_tour_country':
            return <CountryPage data={data} />;
        case 'world_tour_city':
            return <CityPage data={data} />;
        case 'world_tour':
            return <TourPage data={data} />;
        default:
            return "Something went wrong! Page type doesn't exist.";
    }
};

const PageFromSlug = ({ data, isMobile }) => {
    if (!data) {
        return <div>Page not found</div>; // Fallback for unexpected cases
    }

    // Destructure data for easier access
    const {
        regions,
        header,
        footer,
        socialLinks,
        searchOptions,
        isWorldTour = false,
        page,
    } = data?.data || {};


    const { type, data: pageData } = page || {};
    const dropdownData = pageData?.showDropdown ? pageData?.dropdowns : [];

    return (
        <MainWrapper
            regionsData={regions}
            headerData={header}
            footerData={footer}
            socialLinks={socialLinks}
            searchOptions={searchOptions}
            isWorldTour={isWorldTour}
            dropdownData={dropdownData}
            isMobileDefault={isMobile}
            whatsappData={page?.data?.whatsapp}
        >
            {renderPage(type, data)}
        </MainWrapper>
    );
};


// export const getStaticPaths = async () => {
//     return await fetchStaticPaths("getAllSlugs", ({ slug }) => ({
//         params: { slug },
//     }));
// };

export const getServerSideProps = async (context) => {
    const { slug } = context.params;

    if(slug.includes('monitoring')){
        return {
            props: {},
        };
    }

    return await fetchStaticProps("getDataBySlug", { slug },context);
};

export default PageFromSlug;
